export default {
  common: {
    title: '物流管理系统',
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
    reset: '重置',
    search: '搜索',
    add: '新增',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    back: '返回',
    operation: '操作',
    status: '状态',
    createTime: '创建时间',
    updateTime: '更新时间'
  },
  message: {
    success: '操作成功',
    error: '操作失败',
    warning: '警告',
    info: '提示',
    confirmDelete: '确定要删除吗？'
  },
  login: {
    title: '登录',
    username: '用户名',
    password: '密码',
    loginBtn: '登录'
  },
  language: {
    language: '语言',
    german: '德语',
    english: '英语',
    chinese: '中文',
    polish: '波兰语'
  },
  nav: {
    home: '首页',
    about: '关于',
    services: '服务',
    blog: '博客',
    contact: '联系'
  },
  banner: {
    title1: '全球最佳运输解决方案',
    text1: '多条国际航线，直达空运。最大物流折扣，透明收费，无隐藏费用。',
    title2: '全球最佳运输解决方案',
    text2: '通过精确的流程，效率比竞争对手高30%-40%。按需使用，随时扩展，避免旺季仓储问题。',
    title3: '全球物流服务的引领者',
    text3: '简化国际贸易。',
    requestQuote: '请求报价'
  },
  tracking: {
    placeholder: '请输入您的物流运单号',
    query: '查询',
    title: '物流信息',
    noInfo: '无信息',
    trackingNumber: '物流运单号',
    loading: '物流数据加载中...',
    customerName: '收件人',
    mobile: '联系电话',
    address: '地址',
    goodsName: '货物名称',
    timelineTitle: '物流轨迹'
  },
  services: {
    title: '服务',
    subtitle: '为跨境电商卖家服务',
    description: '不用担心配送问题，订单会及时处理。',
    landTransport: '陆运',
    landTransportDesc: '国际快递、DHL、UPS和邮政包裹最低折扣，享受最低折扣。',
    airFreight: '空运',
    airFreightDesc: '提供前往美洲、欧洲、日本及其他地区的各种直达空运服务。',
    warehouse: '仓储',
    warehouseDesc: '免费仓储，一次性委托，仓储、出库、包装和贴标。',
    seaFreight: '海运',
    seaFreightDesc: '整合来自香港的优质国际航运资源，实现全球导航。',
    homeDelivery: '送货上门',
    homeDeliveryDesc: '您只需支付一定的国际物流费用，我们直接将您的货物送到家。',
    support24x7: '24x7 支持',
    support24x7Desc: '多年跨境电商服务经验，7*24小时在线客服，无时区限制服务。',
    readMore: '了解更多',
    bestServices: '我们的最佳服务',
    bestServicesSubtitle: '我们为从事跨境电商的企业、商店和个人提供服务。',
    internationalShipping: '国际航运',
    internationalShippingDesc: '国际物流费用最大折扣，可帮助您节省物流成本。',
    packageProtection: '包裹保护',
    packageProtectionDesc: '代发货、分拣包装、打印订单标签，节省人力成本。',
    freightSupport: '货运支持',
    freightSupportDesc: '货运支持',
    onTimeDelivery: '准时送达',
    onTimeDeliveryDesc: '运营效率比竞争对手高30%-40%，错误率低，用户体验完美。',
    logisticsWork: '物流工作',
    logisticsWorkDesc: '免费API有效管理仓储信息、商品信息、订单信息和物流信息。',
    supportDesc: '按需使用仓储空间有助于您避免淡季空仓和旺季爆仓的问题。',
    exploreAll: '探索所有服务'
  },
  about: {
    title: '关于我们',
    mainTitle: '数字化和值得信赖的运输公司',
    description: 'GG是专为出口型电商开发的新型仓储服务模式，基于互联网管理。',
    point1: '客户批量将货物带入云仓；',
    point2: 'GG根据销售订单直接从云仓分拣、包装、打印和贴标货物，并进行运输和配送；',
    description2: 'GG企业云仓是一个综合供应链服务，集成了仓储管理、国际运输、海外清关和信息管理。它可以帮助客户突破仓储和物流瓶颈，节省成本，提高客户满意度，开拓海外市场。',
    experience: '我们拥有超过年的经验',
    readMore: '了解更多',
    contact: '联系'
  },
  choose: {
    title: '为什么选择我们',
    mainTitle: '我们为运输提供快速、更好的解决方案',
    description: 'Global Goods企业云仓是专为出口型电商开发的新型仓储服务模式，基于互联网管理。它可以为外贸电商提供仓储、分拣包装、单据打印和贴标、国际物流、海外配送等完整解决方案，同时享受超低国际运费。帮助客户突破仓储和物流瓶颈，节省成本，提高客户满意度，开拓海外市场。',
    internationalShipping: '国际运输',
    packageProtection: '包裹保护',
    homeDelivery: '送货上门',
    deliveryTime: '交货时间',
    contact: '联系'
  },
  team: {
    title: '我们的团队',
    description: '每个人都说这个，但在我们的情况下这是真的：我们的团队是我们成功的秘诀。每个员工都很优秀，但在一起，他们是使Rostrum成为如此有趣和有价值的工作场所的关键。Rostrum团队是一个紧密联系、才华横溢的团队，共同愿景是为客户持续提供卓越成果，同时确保公司是一个有趣、包容、具有挑战性的工作场所，并发展具有丰厚回报的职业。',
    follow: '关注'
  },
  gallery: {
    title: '我们的画廊',
    description: 'Global Goods在全球范围内开展广泛的业务活动，其六个业务部门、一个倡议和区域组织在全球范围内紧密合作。通过战略性和有机地整合我们坚实的业务基础和多样化的高级功能，我们通过主动应对变化并超越现有框架来帮助解决社会问题，从而创造新价值。',
    all: '全部',
    airFreight: '空运',
    waterFreight: '水运',
    shipping: '运输',
    shippingTitle: '运输',
    expertTeam: '专家团队',
    expertMember: '专家成员',
    carTransport: '汽车运输',
    seaport: '海港',
    container: '集装箱',
    packaging: '包装'
  },
  funfact: {
    productDelivery: '产品交付',
    totalBranches: '总分支机构',
    satisfiedCustomers: '满意客户',
    ownVehicles: '自有车辆'
  },
  blog: {
    title: '最新新闻和博客',
    description: '查找WIRED的最新博客新闻。查看相关文章、照片、幻灯片和视频。',
    readMore: '了解更多',
    comments: '评论',
    title1: '疫情期间空运可能变得昂贵',
    excerpt1: '大幅减少的运输能力和对防护设备的紧急需求推高了空运服务的价格...',
    title2: '新的货运服务在全球市场开放',
    excerpt2: '在这个市场的顶端，全球货运代理必须承诺在货物运输中保持灵活态度。对新事物保持开放...',
    title3: '运输费用已从',
    excerpt3: '由于运输对经济成功的直接影响，政府传统上比大多数情况下更多地参与货运代理的做法...'
  },
  transport: {
    title: '运输',
    mainTitle: '将您的货物运送到任何地方',
    description: '参考时限：指货物的正常运输时间。也就是说，基于大数据计算，大多数包裹可能因天气、海关检查、港口拥堵、物流仓库爆炸等问题而延迟，从网络访问查询时间到货物到达目的地。具体情况取决于实际运输。',
    requestQuote: '请求报价',
    formTitle: '请求报价',
    name: '姓名',
    request: '请求报价',
    length: '长度 (CM)',
    width: '宽度 (CM)',
    weight: '重量 (KG)',
    distance: '距离 (KM)',
    city: '城市',
    transportType: '运输类型',
    airFreight: '空运',
    roadTransport: '公路运输',
    railTransport: '铁路运输',
    seaFreight: '海运',
    submit: '立即提交',
    contact: '联系'
  },
  newsletter: {
    title: '通过我们的最新通讯保持最新状态',
    placeholder: '请输入您的电子邮件地址',
    subscribe: '订阅'
  },
  footer: {
    followUs: '关注我们',
    quickLinks: '快速链接',
    about: '关于',
    services: '服务',
    currentWork: '当前工作',
    expertTeam: '专家团队',
    newsBlog: '新闻和博客',
    support: '支持',
    faqs: '常见问题',
    pricing: '定价',
    privacyPolicy: '隐私政策',
    terms: '服务条款',
    globalLocations: '全球位置',
    partners: '我们的合作伙伴',
    copyright: '版权 @2024 fairy. 由设计',
    menu: '菜单'
  }
}
